import React from "react";
import "./customToggleButton.scss";

const CustomToggleButton = ({ checked, key, handleChange }) => {
  return (
    <div className="custom-toggle-btn offset-sm-1 ">
      <label
        className="ctb-switch"
        for={key ? key : "checkbox"}
        onClick={(e) => {
          e.preventDefault();
          handleChange();
        }}
      >
        <input
          className={checked ? "ctb-status-checked" : ""}
          type="checkbox"
          id={key ? key : "checkbox"}
          checked={checked}
        />
        <div className="ctb-slider ctb-round"></div>
      </label>
    </div>
  );
};

export default CustomToggleButton;
